var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.618 12.3278C23.618 11.5005 23.5437 10.705 23.4059 9.94141H12.418V14.4543H18.6968C18.4263 15.9126 17.6043 17.1482 16.3687 17.9755V20.9028H20.1392C22.3452 18.8717 23.618 15.8808 23.618 12.3278Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4179 23.7352C15.568 23.7352 18.2089 22.6905 20.1392 20.9086L16.3687 17.9814C15.324 18.6814 13.9876 19.095 12.4179 19.095C9.37931 19.095 6.80734 17.0427 5.88992 14.2852H1.99219V17.3079C3.91189 21.1208 7.85734 23.7352 12.4179 23.7352Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.88864 14.2842C5.6553 13.5842 5.52273 12.8365 5.52273 12.0675C5.52273 11.2986 5.6553 10.5509 5.88864 9.85085V6.82812H1.99091C1.20076 8.40313 0.75 10.1849 0.75 12.0675C0.75 13.9501 1.20076 15.7319 1.99091 17.3069L5.88864 14.2842Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4179 5.03859C14.1308 5.03859 15.6687 5.62723 16.8778 6.78329L20.224 3.43708C18.2036 1.5545 15.5626 0.398438 12.4179 0.398438C7.85734 0.398438 3.91189 3.01283 1.99219 6.82571L5.88992 9.84844C6.80734 7.09087 9.37931 5.03859 12.4179 5.03859Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/googleIcon.01882ef9fac13cd4c823e7c8aa6dda23.svg";
export { ForwardRef as ReactComponent };